'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TenantId$() {
  this.cbt = null;
  this.cbu = false;
}
export { $c_Lpresto_types$TenantId$ as $c_Lpresto_types$TenantId$ };
$p = $c_Lpresto_types$TenantId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TenantId$;
/** @constructor */
function $h_Lpresto_types$TenantId$() {
}
export { $h_Lpresto_types$TenantId$ as $h_Lpresto_types$TenantId$ };
$h_Lpresto_types$TenantId$.prototype = $p;
$p.cHQ = (function() {
  if ((!this.cbu)) {
    this.cbt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cbu = true;
  }
  return this.cbt;
});
var $d_Lpresto_types$TenantId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TenantId$, "presto.types$TenantId$", ({
  a2w: 1,
  D: 1
}));
export { $d_Lpresto_types$TenantId$ as $d_Lpresto_types$TenantId$ };
var $n_Lpresto_types$TenantId$;
function $m_Lpresto_types$TenantId$() {
  if ((!$n_Lpresto_types$TenantId$)) {
    $n_Lpresto_types$TenantId$ = new $c_Lpresto_types$TenantId$();
  }
  return $n_Lpresto_types$TenantId$;
}
export { $m_Lpresto_types$TenantId$ as $m_Lpresto_types$TenantId$ };
//# sourceMappingURL=presto.types$-Tenant-Id$.js.map
